import { SITE, FAQ, type FaqItem, type SiteConfig } from "./site";

export type JsonLd = Record<string, unknown>;

export const buildOrganization = (site: SiteConfig = SITE): JsonLd => {
  const data: JsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: site.name,
    url: site.url,
    logo: site.logo,
  };

  if (site.sameAs.length > 0) {
    data.sameAs = [...site.sameAs];
  }

  if (site.contactPoint?.telephone) {
    const contactPoint: Record<string, unknown> = {
      "@type": "ContactPoint",
      telephone: site.contactPoint.telephone,
      contactType: site.contactPoint.contactType,
    };
    if (site.contactPoint.availableLanguage) {
      contactPoint.availableLanguage = site.contactPoint.availableLanguage;
    }
    data.contactPoint = contactPoint;
  }

  return data;
};

export const buildFaqPage = (faq: FaqItem[] = FAQ): JsonLd => {
  const data: JsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
  };

  const confirmed = faq.filter((item) => !item.pending);

  if (confirmed.length > 0) {
    data.mainEntity = confirmed.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    }));
  }

  return data;
};
